import CharmInfo from './schema/CharmInfo';
import CharmsInfoSchema from './schema/CharmsInfoSchema';
import KeywordInfo from './schema/KeywordInfo';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';

let charmsInfoStoreData: CharmsInfoSchema = {
    charmInfoMap: new ObservableMap<string, CharmInfo>(),
    charmInfoMapMaxId: 0,
    keywordsMap: new ObservableMap<string, KeywordInfo>(),
};

let charmsInfoStore = createStore<CharmsInfoSchema>(
    'calendarCharmsInfoStore',
    charmsInfoStoreData
)();

export default charmsInfoStore;
